module.exports = __webpack_public_path__ + "img/josef_bigelmaier.ff6b1e55.png";